import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Collapse,
  TextField,
  MenuItem,
  Stack,
  Select,
  InputLabel,
  FormControl,
  Pagination,
  Link,
  Grid,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { axiosClient } from "../../services/axiosClient";

const statusColors = {
  Paid: "Paid",
  Completed: "success",
  Pending: "warning",
  Failed: "error",
};


function TransactionRow({ row ,handleUpdateOrder}) {
  const [open, setOpen] = useState(false);
  const [store, setStore] = useState(null);
 console.log(row)
  const fetchStore = async (storeId) => {
       await fetch(`${process.env.REACT_APP_SERVER_URL}/stores/${storeId}`)
        .then((response) => response.json())
        .then((data) => {
          setStore(data.store[0]);
        })
        .catch((error) => {
          console.error("Error fetching store data:", error);
        });
  }
  useEffect( () => {
   
  if (!store) {
    fetchStore(row.storeId)
  }
}, [row.storeId, store]);
  return (
    <>
      <TableRow hover onClick={() =>{fetchStore(row.storeId)}}>
        <TableCell>
          <IconButton size="small" onClick={() => {setOpen(!open);fetchStore(row.storeId)}}>
            {open ? <KeyboardArrowUp  /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{row._id}</TableCell>
        <TableCell sx={{ textTransform: "capitalize", fontWeight: "bold"}}>{row.name}</TableCell>
        <TableCell>#{row.orderNumber}</TableCell>       
        <TableCell>{row.quantity}</TableCell>
        <TableCell>π{row.totalPrice}</TableCell>
        <TableCell>π{row.shippingFees}</TableCell>
        <TableCell>{row.totalPrice + row.shippingFees}</TableCell>
        <TableCell>{row.dateCreated}</TableCell>
        <TableCell>
          <Chip label={row.status.title} color={statusColors[row.status.title]} onClick={() => handleUpdateOrder(row._id,row.storeId, row.status.title)} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit >
            <Box sx={{ margin: 2 }}>
             <Grid container direction='row' spacing={2}>
                <Grid item xs={6} sm={6}>
                  <Typography variant="subtitle1" fontWeight={500} gutterBottom>
                Customer Details
              </Typography>
              <Grid container spacing={0}  direction='column'>
               
                <Grid item xs={12} sm={12} md={12}>
               <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    First Name :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.customer?.firstname}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>
              <Grid item xs={12} sm={12} md={12}>
                     <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Last Name :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.customer?.lastname} 
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>
                <Grid item xs={12} sm={12} md={12}>
                     <Grid container >
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Email :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.customer?.email}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>
              <Grid item xs={12} sm={12} md={12}>
                     <Grid container >
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Phone :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.customer.phone}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>

                 <Grid item xs={12} sm={12} md={12}>
                     <Grid container >
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Country :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.shippingData.country}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>
                <Grid item xs={12} sm={12} md={12}>
                        <Grid container >
                <Grid item xs={12}>
                     <Typography>
                transaction Link:{" "}
                <Link href={`https://blockexplorer.minepi.com/mainnet/transactions/${row.txid}`} target="_blank" rel="noopener">
                  View blockexplorer
                </Link>
              </Typography>
                    </Grid>
                    </Grid>
                </Grid>

              </Grid>
                
              
             
             
             {/*  <Typography>Items: {row.details.items}</Typography> 
              <Typography>Payment Method: {row.details.paymentMethod}</Typography>
              <Typography>Delivery Status: {row.details.deliveryStatus}</Typography>*/}
                 </Grid>   
{
           store ?      <Grid item xs={6} sm={6}> {/*  vendor details */}
                   <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Vendor Details
              </Typography>
              <Grid container spacing={2}  direction='column'>

                <Grid item xs={12} sm={12} md={12}>
                     <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Store :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {store.name}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>
                 
                 <Grid item xs={12} sm={12} md={12}>
                     <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Phone :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {store.phone}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>

                 <Grid item xs={12} sm={12} md={12}>
                     <Grid container spacing={0}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Email :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {store.email}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid>

            {/* <Grid item xs={12} sm={12} md={12}>
                     <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                    Phone :
                  </Typography>
                </Grid>
                 <Grid item xs={6}>
                  <Typography variant="subtitle1" gutterBottom>
                 {row.customer.phone}
              </Typography>
                </Grid>
              </Grid>  
                 </Grid> */}
                <Grid item xs={12} sm={12} md={12}>
                        <Grid container >
                <Grid item xs={12}>
                     <Typography>
                store Link:{" "}
                <Link href={`/store?storeId=${row.storeId}`} target="_blank" rel="noopener">
                  View Store
                </Link>
              </Typography>
                    </Grid>
                    </Grid>
                </Grid>

              </Grid>
                
              
             
             
             {/*  <Typography>Items: {row.details.items}</Typography> 
              <Typography>Payment Method: {row.details.paymentMethod}</Typography>
              <Typography>Delivery Status: {row.details.deliveryStatus}</Typography>*/}
                 </Grid> :"...loading"}
             </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function AdminTransactionsPage({transactions,setTransactions,handleUpdateOrder}) {
    

  const [statusFilter, setStatusFilter] = useState("");
  const [productFilter, setProductFilter] = useState("");
  const [istransactionsLoaded, setIsTransactionsLoaded] = useState(false);
   const [currentPage, setCurrentPage] = useState(1);
   const rowsPerPage = 10;


 const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const filteredTransactions = transactions.filter((txn) => {
    const txnDate = new Date(txn.dateCreated).getTime();
    const from = fromDate ? new Date(fromDate).getTime() : null;
    const to = toDate ? new Date(toDate).getTime() : null;

    

    return (

      (!statusFilter || txn.status.title === statusFilter) &&
      (!productFilter || txn.name.toLowerCase().includes(productFilter.toLowerCase())) &&
      (!from || txnDate >= from) &&
      (!to || txnDate <= to)
      
    );
  });
  // 💡 Slice for current page
const paginatedTransactions = filteredTransactions.slice(
  (currentPage - 1) * rowsPerPage,
  currentPage * rowsPerPage
);

 // Calculate page count dynamically
const pageCount = Math.ceil(filteredTransactions.length / rowsPerPage);

  console.log(filteredTransactions)
  useEffect(() => {
     
               const handlegetTransactions = async (page,limit)=>{
                 // console.log("get cart"+userid)
                 //setShowProgress(true)
                 const url = `${process.env.REACT_APP_SERVER_URL}/analytics/transactions/fromdate`;
                 const accessToken = localStorage.getItem('accessToken')
                 /* const config = {
                     headers: {
                         'auth-token':
                           user.auth_token,
                           Authorization:`Bearer ${accessToken}`
         
                       },
                 } */
                 return axiosClient.get(url,{}).then((response) => {
                      //setShowProgress(false)
                     if (response.status===200){
                       try{
                          console.log(response.data)
                          setTransactions(response.data.transactions)
                       }catch(err){
                         console.log(err)
                       }
                     }
                   })
                 
               };
     if (istransactionsLoaded === false && transactions.length===0){
      try{
        handlegetTransactions(0,10).then((response) => {
        });
      }catch(err){
        console.log(err)
      }
      }
      return () => {
        setIsTransactionsLoaded(true);
      }
      
  }, [istransactionsLoaded, setTransactions, transactions.length]);
   
  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Transactions
      </Typography>

      {/* Filters */}
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={3}>
        <FormControl fullWidth>
          <InputLabel>Status</InputLabel>
          <Select
            value={statusFilter}
            label="Status"
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="Paid">Paid</MenuItem>
            <MenuItem value="Completed">Completed</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Failed">Failed</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Product Name"
          variant="outlined"
          fullWidth
          value={productFilter}
          onChange={(e) => setProductFilter(e.target.value)}
        />

      <TextField
          label="From Date"
          type="datetime-local"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <TextField
          label="To Date"
          type="datetime-local"
          fullWidth
          InputLabelProps={{ shrink: true }}
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />
      </Stack>

      {/* Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Transaction ID</TableCell>
              <TableCell>Product</TableCell>
              <TableCell>OrderNumber</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Shipping Fees</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedTransactions.map((row) => (
              <TransactionRow key={row._id} row={row} handleUpdateOrder={handleUpdateOrder} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Stack direction="row" justifyContent="center" mt={4}>
         <Pagination
            count={pageCount}
            page={currentPage}
            onChange={(e, value) => setCurrentPage(value)}
            color="primary"
         />
      </Stack>
    </Box>
  );
}
